import { Icon } from '@chakra-ui/react';

export const WarningIcon = (props: any) => (
  <Icon aria-label="warning icon" {...props}>
    <path
      d="m11.9998833 5.44943613-7.20941974 14.41883937h14.41883944zm.9533361-2.86000849 8.934021 17.86804206c.2632566.526513.049845 1.1667477-.476668 1.4300042-.1480008.0740004-.3111982.1125261-.4766681.1125261h-17.86804207c-.58865945 0-1.06586223-.4772028-1.06586223-1.0658622 0-.1654699.03852569-.3286674.11252607-.4766681l8.93402103-17.86804206c.2632565-.52651303.9034912-.7399246 1.4300042-.47666809.2062736.10313678.3735313.27039454.4766681.47666809zm-1.9532194 7.41057236h2v6h-2zm1 9c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1-1 .4477153-1 1 .4477153 1 1 1z"
      fill="currentColor"
    />
  </Icon>
);
